<nav class="sidenav shadow-right" id="sidenavAccordion" [ngClass]="sidenavStyle">
	@if (
		accountService.isAppMember &&
		accountService.hasSessionAccount &&
		![AccountProductType.SUP, AccountProductType.SIG, AccountProductType.VIS].includes(accountService.currentProduct?.type)
	) {
		<div class="sidenav-header bg-dark sidenav-module">
			<div class="sidenav-header-content">
				<div class="sidenav-menu-heading text-secondary">Módulos</div>

				@for (product of accountService.products; track $index) {
					@if (product.activated && ![AccountProductType.SUP, AccountProductType.SIG, AccountProductType.VIS].includes(product.type)) {
						@let subscription = accountProducts.moduleSubscription(product.type);
						<button
							class="nav-link"
							(click)="changeProduct(product.type)"
							[ngClass]="{
								'text-secondary fw-900': accountService.product.type === product.type,
								'module-inactive': !accountProducts.moduleActive(product.type)
							}">
							<div class="nav-link-icon">
								<fa-icon [icon]="product.icon" [ngClass]="{ 'text-secondary': accountService.product.type === product.type }"></fa-icon>
							</div>
							{{ product.name }}
							@if (subscription.status === ProductSubscriptionStatus.GRACE_PERIOD) {
								<span
									class="module-subscription-icon text-warning ms-auto"
									role="img"
									aria-label="Módulo em carência"
									[ngbTooltip]="accountProducts.moduleGraceMessage(product.type, false)"
									placement="right"
									container="body">
									<fa-icon icon="triangle-exclamation"></fa-icon>
								</span>
							} @else if (subscription.status === ProductSubscriptionStatus.SUSPENDED) {
								<span
									class="module-subscription-icon text-danger ms-auto"
									role="img"
									aria-label="Módulo suspenso"
									[ngbTooltip]="accountProducts.moduleSuspendedMessage(product.type, false)"
									placement="right"
									container="body">
									<fa-icon icon="ban"></fa-icon>
								</span>
							}
						</button>
					}
				}
			</div>
		</div>
	}

	<div class="sidenav-menu">
		<div class="nav" style="width: 240px; padding-right: 5px">
			@for (section of sideNavSections$ | async; track $index) {
				@if (!isSectionHiddenOnMobile(section)) {
					@if (activeSectionText(section)) {
						@if (section.text) {
							<div class="sidenav-menu-heading">
								{{ section.text }}
							</div>
						}
					}
					@for (item of section?.items; track item.sideNavItemName) {
						@if (item.active) {
							@if (sideNavItems$ | async; as sideNavItems) {
								@if (sideNavItems?.[item.sideNavItemName]?.active) {
									<sbpro-side-nav-item [sideNavItem]="sideNavItems[item.sideNavItemName]"></sbpro-side-nav-item>
								}
							}
						}
					}
				}
			}
		</div>
	</div>
	<div class="sidenav-footer">
		<div class="sidenav-footer-content">
			<div class="sidenav-footer-subtitle">Conectado com</div>
			@if (accountService.user$ | async; as user) {
				<div class="sidenav-footer-title text-secondary text-truncate fw-700">
					{{ user.name?.toUpperCase() }}
				</div>
			}
		</div>
	</div>
</nav>
